import * as passwordValidator from './password';

export const validators = {
    // todo: deprecated, remove when legacy app is removed
    ...passwordValidator,
};

export * from './dynamicField';
